import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import FilterNDownload from '../Components/FilterNDownload';
import SamplebookList from '../Components/SamplebookList';

import SampleBookService from '../Services/SampleBookService';
import samplebook from '../Types/samplebook';

const MainPage = () => {
  const [design, setDesign] = useState<string>('');
  const [sampleList, setSampleList] = useState<samplebook[]>([]);
  const [tempList, setTempList] = useState<samplebook[]>([]);
  const [mainColorList, setMainColorList] = useState<string[]>([]);
  const [selectedColor, setSelectedColor] = useState<string>('');
  const [filteredList, setFilteredList] = useState<samplebook[]>([]);
  const [colorNameList, setColorNameList] = useState<{ color: string; value: string[] }[]>([]);
  const [pdfData, setPdfData] = useState<{ design: string; pdf: string }>({
    pdf: '',
    design: '',
  });

  const params = useParams();

  useEffect(() => {
    const getColorNameList = async () => {
      const res = await SampleBookService.getColorNameList();
      if (res.status === 'success') {
        setColorNameList(res.data);
      }
    };
    getColorNameList();
  }, []);

  useEffect(() => {
    const s = params.design;
    let d = '';
    if (!!s) {
      d = s;
    }
    if (!!d) {
      setDesign(d);
    }
  }, [params]);

  useEffect(() => {
    if (!design || design === '') return;

    const getSampleBookList = async () => {
      const res = await SampleBookService.getSampleBookList();
      if (res.status === 'success') {
        setSampleList(res.data.filter((r) => r.design === design));
      } else {
        setSampleList([]);
      }
    };
    getSampleBookList();

    const getPDF = async () => {
      const res = await SampleBookService.getPDF();
      if (res.status === 'success') {
        setPdfData(res.data.filter((r) => r.design === design)[0] || '');
      }
    };
    getPDF();
  }, [design]);

  useEffect(() => {
    if (!colorNameList || colorNameList.length < 1) return;

    const arr: samplebook[] = [];

    for (const s of sampleList) {
      for (const c of colorNameList) {
        for (const v of c.value) {
          if (s.main.localeCompare(v) === 0) {
            arr.push({
              ...s,
              main: c.color,
            });
          }
        }
      }
    }
    setTempList(arr);
  }, [sampleList, colorNameList]);

  useEffect(() => {
    const arr: string[] = ['All'];
    for (const s of tempList) {
      if (!arr.includes(s.main)) {
        arr.push(s.main);
      }
    }
    setMainColorList(arr);
  }, [tempList]);

  useEffect(() => {
    if (!!selectedColor && selectedColor !== '' && selectedColor !== 'All') {
      setFilteredList(tempList.filter((s) => s.main === selectedColor));
    } else {
      setFilteredList(tempList);
    }
  }, [selectedColor, tempList]);

  return (
    <Box>
      <FilterNDownload pdf={pdfData.pdf} filterList={mainColorList} setSelectedColor={setSelectedColor} design={design} />
      <SamplebookList sampleList={filteredList} />
    </Box>
  );
};

export default MainPage;
